(function notificationPopupModuleDefinition() {

    'use strict';

    angular.module('NotificationPopup', ['Auth', 'AuthExtend', 'Language', 'ui.router', 'Config', 'EqualsValidation', 'ErrorsExtend', 'UnitOrgControl', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function notificationPopupConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('notification-popup', {
                    url: "/",
                    templateUrl: config.resourceUrl('/views/notification-popup/popup.html'),
                    controller: 'NotificationPopupController',
                    authorize: true
                });
            }
        ]);
})();